import { Box, Chip, Typography, Grid } from "@mui/material"
import { Subscription } from "../../../__generated__/graphql";
type CompanySubscriptionType = {
    endDate: string | Date;
    id: string,
    name: string,
    startDate: string | Date;
    subscription: Subscription
}
function getActiveSubs(subs: CompanySubscriptionType[]) {
    const now = new Date();
    return subs.filter(sub => new Date(sub.endDate) >= now) ?? undefined
}

const SubscriptionCell = ({ subs }: any) => {
    const activeSubs = getActiveSubs(subs)
    return (
        <Grid container spacing={1} sx={{ padding: 2, justifyContent: "center" }}>
            {activeSubs.length > 0 ? (
                activeSubs.map((activeSub, index) => (
                    <Grid key={`tags-chip-${activeSub.subscription.name}-${index}`} style={{ marginTop: 1 }}>
                        <Chip className="chip" label={activeSub.subscription.description} />
                    </Grid>
                ))
            ) : (<Typography sx={{ fontSize: ".875rem" }} >No Active Subscriptions</Typography>)
            }
        </Grid>
    )
}

export default SubscriptionCell